import React, { useEffect, useState } from 'react'
import styled from 'styled-components'


export default ({ slides = [], activeSlide = 0, showNav = true }) => {
    const [ active, setActive ] = useState(activeSlide);

    return (
        <Style slidesLength={slides.length} focusOn={active}>
            <div className="carousel__wrap">
                <ul>
                    { slides.map((slide, i) => (
                        <li key={i}>
                            { slide }
                        </li>
                    ))}
                </ul>
            </div>
            { showNav && (
                <div className="carousel__nav">
                    { slides.map((slide, i) => (
                        <button type="button" onClick={() => setActive(i)} disabled={active === i}>dot</button>
                    ))}
                </div>
            )}
        </Style>
    )
}


const Style = styled.div.attrs(props => ({
    className: 'carousel'
}))`
    margin-top: 3em;
    width: 100%;
    overflow: hidden;
    position: relative;
    padding-bottom: 3em;

    .carousel__wrap {
        width: 100%;
        transform: ${props => `translateX(${-100 * props.focusOn}%)`};
        transition: transform .4s ease;
    }

    .carousel__wrap > ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        list-style:none;
        padding: 0;
        margin:0;
        width: ${props => `calc(100% * ${props.slidesLength})`};

        > li {
            width: 100%;
            margin-bottom: 0;
        }
    }

    li {
        margin-bottom: 0;
    }

    .carousel__nav {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: inline-flex;
        z-index:10;

        > button {
            width: 11px;
            height: 11px;
            padding: 0;
            border-radius: 50%;
            text-indent: -5000px;
            display: block;
            background-color: var(--black);
            border: none;
            position: relative;
            cursor: pointer;
            outline: none;
            margin: 0 .25em;

            &:hover, &:focus {
                opacity: .85;
            }

            &:disabled {
                background-color: var(--red);
            }

            > svg {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateY(-50%) translateX(-50%);
                color: var(--light);
            }

            + button svg {
                transform: translateY(-50%) translateX(-50%) rotate(180deg);
            }
        }
    }


`